import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { Mail } from 'lucide-react';
import { listEmailTemplates } from '@/lib/api/admin';
import type { EmailTemplateKind } from '@/lib/api/types';
import { Badge } from '@/components/ui/badge';
import { DataTable, type Column } from '@/components/ui/data-table';
import { PageHeader } from '@/components/ui/page';
import { EMAIL_LOCALES, GROUP_LABEL } from './editor';

/** Every email the platform sends, and which languages carry edited wording. */
export function EmailTemplatesPage() {
  const navigate = useNavigate();
  const kinds = useQuery({ queryKey: ['admin', 'email-templates'], queryFn: listEmailTemplates });

  const columns: Column<EmailTemplateKind>[] = [
    { key: 'title', header: 'Письмо', sortValue: (r) => r.title, render: (r) => <span className="font-semibold text-ink">{r.title}</span> },
    { key: 'group', header: 'Группа', sortValue: (r) => r.group, hideBelow: 'md', render: (r) => GROUP_LABEL[r.group] ?? r.group },
    {
      key: 'locales',
      header: 'Языки',
      render: (r) => (
        <span className="flex gap-1.5">
          {EMAIL_LOCALES.map((l) => (
            <Badge key={l} tone={r.customized[l] ? 'accent' : 'neutral'}>{r.customized[l] ? `${l} · изменён` : l}</Badge>
          ))}
        </span>
      ),
    },
  ];

  return (
    <>
      <PageHeader title="Письма" subtitle="Тексты всех писем платформы на трёх языках. Язык, который не правили, берёт текст из кода." />
      <DataTable
        id="et_"
        rows={kinds.data ?? []}
        columns={columns}
        rowKey={(r) => r.kind}
        defaultSort={{ key: 'group', dir: 'asc' }}
        loading={kinds.isPending}
        error={kinds.error}
        onRetry={() => kinds.refetch()}
        onRowClick={(r) => navigate(`/email-templates/${encodeURIComponent(r.kind)}`)}
        empty={{ icon: <Mail size={28} />, title: 'Писем нет' }}
      />
    </>
  );
}
